<template>
	<div id="index">
		<div class="container">
			<div class="left">
				<div class="top">
					<!-- <el-popover placement="bottom-end"  width="250" trigger="hover"
						:content="schoolInfo.company_name || '校招平台用户'"> -->
					<!-- <el-tooltip class="item" effect="dark" content="Bottom Center 提示文字" placement="bottom">
					      <el-button>下边</el-button>
					    </el-tooltip> -->
					<template v-if="nextToken">
						<!-- <el-tooltip class="item" effect="dark" :content="schoolInfo.company_name || ''"
								placement="bottom"> -->
						<div class="companyInfo" @click="toLogin" :title="schoolInfo.company_name || ''">
							<img v-if="schoolInfo.logo" :src="schoolInfo.logo"></img>
							<div class="company_name" style="background-color: #FF6600"
								v-else-if='schoolInfo.company_name'>
								{{schoolInfo.company_name?schoolInfo.company_name.substring(0,1):''}}
							</div>
							<div class="company_name" v-else>
								<img
									src="https://new-shengxue985.oss-cn-hangzhou.aliyuncs.com/2026/03/30/3tvqignqph9eepyd.png"></img>
							</div>
							<div class="company_name1">
								{{ schoolInfo.company_name || '点击登录/注册' }}
							</div>
						</div>
						<!-- </el-popover> -->
						<!-- </el-tooltip> -->
					</template>

					<template v-else>
						<div class="companyInfo">
							<div class="company_name">
								<img
									src="https://new-shengxue985.oss-cn-hangzhou.aliyuncs.com/2026/03/30/3tvqignqph9eepyd.png"></img>
							</div>
							<div class="company_name1" @click="toLogin">
								{{ '点击登录/注册' }}
							</div>
						</div>
					</template>
					<!-- <el-button>下边</el-button> -->

					<el-menu :default-active="defaultActive" class="el-menu-vertical-demo" @open="handleOpen"
						@select='menuSelect' :collapse="isCollapse" background-color='#1E40AF'>
						<el-menu-item index="1">
							<!-- <i class="el-icon-menu"></i> -->
							<div class=""
								style="margin-right: 5px;padding: 0 3px;display: flex;align-items: center;display: inline-block;">
								<img src="../img/idx1.png" alt=""
									style="width: 13px;height: 13px;margin-bottom: 2px;" />
							</div>
							<span slot="title">主页</span>
						</el-menu-item>
						<el-menu-item index="2">
							<div class=""
								style="margin-right: 5px;padding: 0 3px;display: flex;align-items: center;display: inline-block;">
								<img src="../img/idx2.png" alt=""
									style="width: 13px;height: 13px;margin-bottom: 2px;" />
							</div>
							<span slot="title">企业详情</span>
						</el-menu-item>
						<el-menu-item index="7">
							<div class=""
								style="margin-right: 5px;padding: 0 3px;display: flex;align-items: center;display: inline-block;">
								<img src="https://new-shengxue985.oss-cn-hangzhou.aliyuncs.com/2025/10/21/b3ahvfwmzff0amy9.png"
									alt="" style="width: 13px;height: 13px;margin-bottom: 2px;" />
							</div>
							<span slot="title">双选会</span>
						</el-menu-item>
						<el-menu-item index="3">
							<div class=""
								style="margin-right: 5px;padding: 0 3px;display: flex;align-items: center;display: inline-block;">
								<img src="../img/idx3.png" alt=""
									style="width: 13px;height: 13px;margin-bottom: 2px;" />
							</div>
							<span slot="title">职位管理</span>
						</el-menu-item>
						<el-menu-item index="4">
							<div class=""
								style="margin-right: 5px;padding: 0 3px;display: flex;align-items: center;display: inline-block;">
								<img src="../img/idx4.png" alt=""
									style="width: 14px;height: 13px;margin-bottom: 2px;" />
							</div>
							<span slot="title">消息管理</span>
							<span v-if="unreadMessageCount > 0" class="message-unread-badge">{{ unreadMessageCount > 99 ? '99+' : unreadMessageCount }}</span>
						</el-menu-item>
						<el-menu-item index="5">
							<div class=""
								style="margin-right: 5px;padding: 0 3px;display: flex;align-items: center;display: inline-block;">
								<img src="../img/idx5.png" alt=""
									style="width: 14px;height: 14px;margin-bottom: 2px;" />
							</div>
							<span slot="title">个人中心</span>
						</el-menu-item>
						<!-- <el-menu-item index="6">
						<i class="el-icon-menu"></i>
						<span slot="title">系统设置</span>
					</el-menu-item> -->

					</el-menu>
				</div>

				<div class="bottom" v-if="nextToken">
					<!-- <img :src="qrcodeImg" alt="" v-if="qrcodeImg" /> -->
                   
                    <div class="img-box" v-if="qrcodeImg">
                        <img class='imglogo' src="https://new-shengxue985.oss-cn-hangzhou.aliyuncs.com/2026/06/02/logopt.png" alt="" />
                    </div>
					<div class="">
						扫码使用手机端
					</div>
				</div>
			</div>
			<div class="right" :class="{ hasMeetingBanner: $route.path === '/meeting' }">
				<div v-if="$route.path === '/meeting'" class="meetingBanner">
					<img src="https://oss.sx985.com/2023/03/24/ff8983660f3948054fb5eddbc5f5e970.jpg" alt="千校联合报名平台" />
				</div>
				<div class="rightHeader">

					<div class="titleContainer">
						<img src="../img/more.png" alt="" />
						<div class="navigation">
							<div class="navigationItem" v-for="(item,index) in navigation" :key="index"
								:style="item.name!='/'?'cursor: pointer;':''" @click="navigationTo(item)">
								{{item.name}}
							</div>
						</div>
					</div>
					<div class="center">
					</div>
					<div class="userInfo">
						<div v-if="$route.path === '/meeting'" class="meetingDocumentButton">
							<div class="activityIntroductionText">活动介绍：</div>
							<div class="activityAction schoolLink" @click.stop="$router.push('/activityIntroduction')">
								<img src="https://new-shengxue985.oss-cn-hangzhou.aliyuncs.com/2026/06/05/iio1.png" alt="" />
								<span>高校链接</span>
							</div>
							<a class="activityAction documentLink" href="https://www.sx985.com/千校万企联合促就业活动介绍.pdf" target="_blank" rel="noopener">
								<img src="https://new-shengxue985.oss-cn-hangzhou.aliyuncs.com/2026/06/05/iio2.png" alt="" />
								<span>文档</span>
							</a>
							<div class="activityAction videoLink" @click="videoDialogVisible = true">
								<img src="https://new-shengxue985.oss-cn-hangzhou.aliyuncs.com/2026/06/05/iio3.png" alt="" />
								<span>视频</span>
							</div>
						</div>
                        <div v-if="$route.path === '/meeting'" class="meetingline">
                            
                        </div>
						<div class="fullScreen">
							<!-- <img class="img1"
								:src="fullscreen?'https://new-shengxue985.oss-cn-hangzhou.aliyuncs.com/2025/02/25/fildtrneftzlfyfp.png':'https://new-shengxue985.oss-cn-hangzhou.aliyuncs.com/2025/02/25/l6axibjujeblbtid.png'"
								alt="" @click="toggleFullScreen" /> -->
							<div class="userName" style="color: #606266;font-size: 14px;">
								{{userInfo.username?userInfo.username:''}}
							</div>
						</div>

						<template v-if="nextToken">
							<el-dropdown type="primary" @command="handleCommand">
								<div class="userInfoMain">
									<div v-if="nextToken">
										<img class="img2" v-if="userInfo.avatar" :src="userInfo.avatar" alt="" />
										<img class="img2" v-else
											:src="`https://new-shengxue985.oss-cn-hangzhou.aliyuncs.com/2023/11/20/avatar_${(userInfo.user_id) % 26 || 0}.png`"
											alt="" />
									</div>
									<div v-else>
										<img class="img2"
											src="https://new-shengxue985.oss-cn-hangzhou.aliyuncs.com/2026/03/30/3tvqignqph9eepyd.png"
											alt="" />
									</div>
									<img class="img3" src="../img/more1.png" alt="" v-if="nextToken" />
								</div>
								<el-dropdown-menu slot="dropdown">
									<el-dropdown-item command='1'>编辑个人信息</el-dropdown-item>
									<el-dropdown-item command='2'>修改密码</el-dropdown-item>
									<el-dropdown-item command='3'>退出</el-dropdown-item>
								</el-dropdown-menu>
							</el-dropdown>
						</template>
						<template v-else>
							<div class="userInfoMain" @click="toLogin">
								<div style="cursor: pointer;">
									<img class="img2"
										src="https://new-shengxue985.oss-cn-hangzhou.aliyuncs.com/2026/03/30/3tvqignqph9eepyd.png"
										alt="" />
								</div>
							</div>
						</template>
					</div>
					<!-- <el-radio-group v-model="isCollapse" style="margin-bottom: 20px;">
						<el-radio-button :label="false">展开</el-radio-button>
						<el-radio-button :label="true">收起</el-radio-button>
					</el-radio-group> -->
				</div>
				<div class="rightMain" ref='scrollContainer'
					:style="$route.path=='/home'||$route.path=='/commentManagement'?'background: #F0F4FA;':'background: #fff;'">

					<keep-alive>
						<router-view v-if="$route.meta.keepAlive" @update-message-management-navigation="updateMessageManagementNavigation" @update-unread-message-count="getUnreadMessageCount"></router-view>
					</keep-alive>
					<router-view v-if="!$route.meta.keepAlive" @update-message-management-navigation="updateMessageManagementNavigation" @update-unread-message-count="getUnreadMessageCount"></router-view>
				</div>

			</div>
		</div>

		<div class="changePassword">
			<el-dialog title="修改密码" :visible.sync="changeDialogVisible" @close='elDialogClose1' width="500px">
				<div class="elDialogContainer">
					<div class="ipt" style="margin-bottom: 20px;background: #F5F7FA;">
						<div class="text" style="margin-bottom: 0;">
							手机号
						</div>
						<el-input v-model="userInfo.tel" disabled placeholder="请输入手机号"></el-input>
					</div>
					<!-- <div class="ipt" style="margin-bottom: 20px;">
						<div class="text">
							旧密码
						</div>
						<el-input type="password" v-model="oldPassword" placeholder="请输入旧密码"></el-input>
					</div> -->
					<div class="ipt" style="margin-bottom: 20px;align-items: baseline;">
						<div class="text" style="margin-bottom: 0;">
							新密码
						</div>
						<el-input type="password" autocomplete="new-password" v-model="password" show-password
							placeholder="请输入新密码（不少于4位数）"></el-input>
					</div>

					<div class="ipt" style="margin-bottom: 30px;align-items: baseline;">
						<div class="text" style="margin-bottom: 0;">
							确认新密码
						</div>
						<el-input type="password" autocomplete="new-password" v-model="repetitionPassword" show-password
							placeholder="请再次输入新密码"></el-input>
					</div>

				</div>
				<div class="" style="display: flex;align-items: center;justify-content: flex-end;">
					<el-button type="primary" @click="submit2">确认</el-button>
				</div>
			</el-dialog>
		</div>
		<el-dialog title="活动视频" top="15vh !important"  :visible.sync="videoDialogVisible" width="800px" class="activityVideoDialog">
			<video v-if="videoDialogVisible" class="activityVideo" controls 
				src="https://video.sx985.com/sv/575049eb-1a012efa065/575049eb-1a012efa065.mp4"></video>
		</el-dialog>


		<!-- <div class="changePassword">
			<el-dialog title="编辑个人信息" :visible.sync="changeDialogVisible1" @close='elDialogClose1' width="500px">
				<div class="elDialogContainer">
					
					<div class="ipt" style="margin-bottom: 20px;display: flex; padding: 10px 15px;border: none;">
						<div class="text" style="margin-right: 20px;">
							头像
						</div>
						<el-tooltip class="item" effect="dark" content="点击上传/更换头像" placement="top">
							<el-upload class="avatar-uploader"
								action="https://np.sx985.com/admin/upload/uploadOssFile?admin_id=3"
								:show-file-list="false" :on-success="handleAvatarSuccess1"
								:before-upload="beforeAvatarUpload">
								<img v-if="avatar" :src="avatar" class="avatar" style="width: 80px;height: 80px;">
								<div class="avatarUploader" v-else>
									<i class="el-icon-plus avatar-uploader-icon1"></i>
									<span>点击上传</span>
								</div>
							</el-upload>
						</el-tooltip>
					</div>
					
					<div class="ipt" style="margin-bottom: 20px;align-items: baseline;">
						<div class="text">
							姓名
						</div>
						<el-input  v-model="username" placeholder="请输入姓名"></el-input>
					</div>
		
					<div class="ipt" style="margin-bottom: 30px;align-items: baseline;">
						<div class="text">
							职位
						</div>
						<el-input  v-model="job_title" placeholder="请输入职位"></el-input>
					</div>
				</div>
				<div class="" style="display: flex;align-items: center;justify-content: flex-end;">
					<el-button type="primary" @click="submit3">确认</el-button>
				</div>
			</el-dialog>
		</div> -->


		<div class="previewDialogVisible">
			<el-dialog :visible.sync="changeDialogVisible1" :show-close='false' width="600px" @close='elDialogClose1'
				class="previewDialogVisible">
				<div class="previewElDialog elDialogContainer"
					style="background: #fff;background: #FFFFFF;border-radius: 10px;padding: 20px 0;">
					<img class="close" @click="changeDialogVisible1 = false" src="../img/close.png" alt="" />
					<div class=""
						style="line-height: 24px;font-size: 18px;color: #303133;font-weight: bold;padding: 0 20px;margin-bottom: 20px;">
						编辑个人信息
					</div>
					<div class="elDialogContainer" style="background: #f7f9ff;padding: 20px 0;">
						<div class="ipt" style="padding: 0 20px;display: flex;">
							<div class="text" style="margin-bottom: 0px;">
								头像：
							</div>
							<div class="enterprise" style="display: flex;align-items: center;">
								<el-tooltip class="item" effect="dark" content="点击上传/更换头像" placement="right">
									<el-upload class="avatar-uploader"
										style="width: 70px !important;height: 70px !important;"
										action="https://np.sx985.com/admin/upload/uploadOssFile?admin_id=3"
										:show-file-list="false" :on-success="handleAvatarSuccess1"
										:before-upload="beforeAvatarUpload">
										<img v-if="avatar" :src="avatar" class="avatar"
											style="width: 70px !important;height: 70px !important;">
										<div class="avatarUploader" v-else>
											<i class="el-icon-plus avatar-uploader-icon1"></i>
											<span>点击上传</span>
										</div>
									</el-upload>
								</el-tooltip>
								<div class=""
									style="font-size: 14px;color: #999999;margin-right: 20px;margin-left: 20px;">
									<div class="" style="margin-bottom: 5px;">
										建议上传真实头像尺寸1:1，JPG、PNG格式
									</div>
								</div>
							</div>
						</div>

						<div class="ipt" style="padding: 0 20px;display: flex;">
							<div class="text" style="margin-bottom: 0px;">
								姓名：
							</div>
							<el-input v-model="username" maxlength="10" placeholder="请输入姓名"></el-input>
						</div>

						<div class="ipt" style="padding: 0 20px;display: flex;">
							<div class="text" style="margin-bottom: 0px;">
								职位：
							</div>
							<el-input v-model="job_title" maxlength="10" placeholder="请输入职位"></el-input>
						</div>

						<div class="ipt" style="padding: 0 20px;display: flex;">
							<div class="text" style="margin-bottom: 0px;">
								邮箱：
							</div>
							<el-input v-model="email" placeholder="请输入邮箱"></el-input>
						</div>

						<div class="ipt" style="padding: 0 20px;display: flex;">
							<div class="text" style="margin-bottom: 0px;">
								微信：
							</div>
							<div class="enterprise" style="display: flex;align-items: center;">
								<el-tooltip class="item" effect="dark" content="点击上传/更换微信二维码" placement="right">
									<el-upload class="avatar-uploader1"
										style="width: 120px !important;height: 120px !important;"
										action="https://np.sx985.com/admin/upload/uploadOssFile?admin_id=3"
										:show-file-list="false" :on-success="handleAvatarSuccess2"
										:before-upload="beforeAvatarUpload">


										<div class="closeContainer" v-if="wechat" style="position: relative;">
											<img v-if="wechat" :src="wechat" class="avatar"
												style="width: 120px !important;height: 120px !important;">
											<img class="closeImg" src="../img/close1.png" alt="" @click.stop="delWeixin"
												style="width: 15px;height: 15px;position: absolute;right: 5px;top: 5px;" />
										</div>


										<div class="avatarUploader"
											style="width: 120px !important;height: 120px !important;" v-else>
											<i class="el-icon-plus avatar-uploader-icon1"></i>
											<span>点击上传</span>
										</div>
									</el-upload>
								</el-tooltip>
							</div>
						</div>
					</div>

					<div class=""
						style="display: flex;align-items: center;justify-content: flex-end;padding: 20px 20px 0 20px;">
						<el-button type="primary" @click="submit3">保存</el-button>
					</div>

				</div>
			</el-dialog>
		</div>





	</div>
</template>

<script>
    const config = require('../../WebConfig')
	import {
		mapState,
		mapMutations,
		mapActions
	} from 'vuex'
	export default {
		data() {
			return {
				defaultActive: "0",
				isCollapse: false,
				fullscreen: false,

				navigation: [{
					name: '首页',
					path: '/home'
				}],

				// defaultimg: '',



				changeDialogVisible: false,
				changeDialogVisible1: false,
				videoDialogVisible: false,

				phone: '',
				password: '',
				oldPassword: '',
				repetitionPassword: '',

				qrcodeImg: 'https://new-shengxue985.oss-cn-hangzhou.aliyuncs.com/2026/08/01/blcnak5rj1j4wdlf.png',

				avatar: '',
				username: '',
				job_title: '',
				wechat: '',
				email: '',
				pathStaus: 0,
				unreadMessageCount: 0,
				unreadMessageTimer: null,
			}
		},
		computed: {
			...mapState({
				nextToken: state => state.nextToken,
				userInfo: state => state.userInfo,
				schoolInfo: state => state.schoolData,
				adminId: state => state.admin_id,
				defaultimg: state => state.defaultimg,
			}),
		},
		watch: {
			$route(to) {
				this.getNavigationBar(to.path)
				this.getUnreadMessageCount()
				if (to.path == '/jobDetails') {
					this.$refs.scrollContainer.scrollTop = 0
				}
			}
		},

		mounted() {
			if (this.nextToken) {
				this.isLogin = true
			} else {
				this.isLogin = false
			}
			console.log(this.isLogin)
			// let ids = (this.userInfo.user_id) % 10 || 0
			// this.defaultimg = this.userInfo.avatar ||
			// 	`https://new-shengxue985.oss-cn-hangzhou.aliyuncs.com/2023/11/20/avatar_${ids}.png`
			if (this.userInfo) {
				this.avatar = this.userInfo.avatar
				this.wechat = this.userInfo.wechat
				this.username = this.userInfo.username
				this.job_title = this.userInfo.position
				this.email = this.userInfo.email
				// this.email = this.userInfo.email
			}

			
			this.getNavigationBar(this.$route.path)
			this.getUnreadMessageCount()
			this.unreadMessageTimer = setInterval(() => {
				this.getUnreadMessageCount()
			}, 5 * 60 * 1000)
			// this.getQrcode()
			// this.$util.post(
			// 	"/login/login", {
			// 		username: this.ruleForm.username,
			// 		password: this.$md5(this.ruleForm.pass),
			// 	},
			// 	(res) => {
			// 		
			// 		if (res.code == 1) {
			// 			localStorage.setItem("token", res.data.token);
			// 			this.$router.push({
			// 				path: "/main",
			// 				// query: {
			// 				//   id: 1,
			// 				// },
			// 			});
			// 		}
			// 	}
			// );
			let salesmanPhone = localStorage.getItem('salesmanPhone')

			if (salesmanPhone && this.userInfo.user_id) {
				console.log(salesmanPhone)
				let obj = {
					admin_id: this.schoolInfo.admin_id,
					user_id: this.userInfo.user_id,
					business_tel: salesmanPhone
				}
				this.$util.post(
					"v2/school_job/bindBusinessTel", {
						...obj
					},
					(res) => {
						if (res.code === 200) {

						}
					}
				);

			}


		},
		beforeDestroy() {
			if (this.unreadMessageTimer) clearInterval(this.unreadMessageTimer)
		},
		methods: {
			...mapMutations(['setIslogin', 'setAdminId', 'setUserInfo', 'setSchoolData', 'setUserId', 'setToken']),
			...mapActions(['getUserInfo', 'getCompanyUserInfo']),
			delWeixin() {
				this.wechat = ''
			},
			toLogin() {
				if (!this.nextToken) {
					this.$router.push({
						path: '/login',
					})
				}
			},
			getUnreadMessageCount() {
				if (!this.nextToken) {
					this.unreadMessageCount = 0
					return
				}
				const adminId = this.adminId || this.schoolInfo.admin_id || localStorage.getItem('admin_id')
				if (!adminId) return
				// this.$util.post('v2/school_job/get_box_num2', {
				// 	admin_id: adminId,
				// 	source: 2,
				// }, (res) => {
				// 	if (res.code !== 0 && res.code !== 200) return
				// 	const unReadList = res.data && Array.isArray(res.data.un_read) ? res.data.un_read : []
				// 	this.unreadMessageCount = unReadList.reduce((total, item) => total + Math.max(0, Number(item.cnt) || 0), 0)
				// })
			},
			handleAvatarSuccess1(res) {
				this.avatar = res.data.fileUrl;
			},
			handleAvatarSuccess2(res) {
				this.wechat = res.data.fileUrl;
			},
			beforeAvatarUpload(file) {
				const isJPG = file.type === 'image/jpeg';
				const isPNG = file.type === 'image/png';
				const isLt2M = file.size / 1024 / 1024 < 10;
				let img = isJPG || isPNG
				if (!isJPG && !isPNG) {
					this.$message.error('上传图片格式错误!');
					return
				}
				if (!isLt2M) {
					this.$message.error('上传图片大小不能超过 10MB!');
					return
				}

				return isLt2M && img;
			},
			changePassword() {
				this.oldPassword = ''
				this.password = ''
				this.repetitionPassword = ''
				this.changeDialogVisible = true
			},
			getQrcode() {
				this.$util.post(
					"admin/home/qrcode", {
						app_type: 10,
						page_path: 'pages/home/employmentDay',
						is_test: config.IS_TEST 
					},
					(res) => {
						if (res.code == 200) {
							this.qrcodeImg = res.data.qrCode
							// this.sceneId = res.data.scene
							// this.setTimer()
							// localStorage.setItem('qrcodeImg', res.data.qrCode)
						}
					}
				);
			},
			handleCommand(command) {
				if (command == 1) {
					this.changeDialogVisible1 = true
				} else if (command == 2) {
					this.changePassword()
				} else if (command == 3) {
					this.loginOut()
				}
			},

			submit3() {
				if (this.avatar == '') {
					this.$message({
						message: '请上传头像',
						type: 'error'
					});
					return
				}
				if (this.username == '') {
					this.$message({
						message: '请输入姓名',
						type: 'error'
					});
					return
				}

				if (this.job_title == '') {
					this.$message({
						message: '请输入职位',
						type: 'error'
					});
					return
				}
				if (!this.email) {
					this.$message.error('请输入您的邮箱')
					return
				}
				// yi.he@innovi.net.cn
				// sx985@sx985.com
				const regex = /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/i
				if (!regex.test(this.email)) {
					this.$message.error('请输入正确格式的邮箱')
					return
				}

				let abj = {
					email: this.email
				}
				abj.admin_id = this.schoolInfo.admin_id
				abj.position = this.job_title
				// abj.email= this.email
				abj.username = this.username
				abj.avatar = this.avatar
				abj.wechat = this.wechat
				abj.user_id = this.userInfo.user_id
				abj.id = this.userInfo.id
				this.$util.post(
					"v2/school_job/saveCompanyUserInfo", {
						...abj
					},
					(res) => {
						if (res.code == 0) {
							this.$message({
								message: '修改成功',
								type: 'success'
							});
							this.getCompanyUserInfo()
							this.changeDialogVisible1 = false
						} else {
							this.$message.error(res.msg);
						}
					}
				);
			},
			submit2() {
				// if (this.oldPassword == '') {
				// 	this.$message.error('请输入旧密码');
				// 	return
				// }
				if (this.password == '') {
					this.$message.error('请输入新密码');
					return
				}
				let reg = /\s/
				if (reg.test(this.password)) {
					this.$message.error('密码不能含有空格');
					return
				}
				if (this.password.length < 4) {
					this.$message.error('密码长度不能小于4位');
					return
				}
				if (this.password != this.repetitionPassword) {
					this.$message.error('两次密码不一致');
					return
				}
				this.$util.post(
					"v2/school_job/modify_pass", {
						tel: this.userInfo.tel,
						password: this.password,
					},
					(res) => {
						if (res.code == 0) {
							this.$message({
								message: '修改成功',
								type: 'success'
							});
							this.changeDialogVisible = false
						} else {
							this.$message.error(res.msg);
						}
					}
				);
			},

			elDialogClose1() {
				this.changeDialogVisible = false
				this.changeDialogVisible1 = false
			},
			handleClose(done) {
				done();
			},
			getNavigationBar(path) {
				switch (path) {
					case '/home':
						this.defaultActive = "1"
						this.navigation = [{
							name: '主页',
							path: '/home'
						}]
						break;
					case '/pushMessage':
						this.defaultActive = "1"
						this.navigation = [{
							name: '主页',
							path: '/home'
						}, {
							name: '/',
							path: '/'
						}, {
							name: '消息推送',
							path: '/pushMessage'
						}]
						break;
					case '/commentManagement':
						this.defaultActive = "1"
						this.navigation = [{
							name: '主页',
							path: '/home'
						}, {
							name: '/',
							path: '/'
						}, {
							name: '企业社区管理',
							path: '/commentManagement'
						}]
						break;
					case '/liveManagement':
						this.defaultActive = "1"
						this.navigation = [{
							name: '主页',
							path: '/home'
						}, {
							name: '/',
							path: '/'
						}, {
							name: '直播管理',
							path: '/liveManagement'
						}]
						break;
					case '/corporateImage':
						this.defaultActive = "2"
						if (this.$route.query.pathStaus) {
							this.navigation = [{
								name: '双选会',
								path: '/meeting'
							}, {
								name: '/',
								path: '/'
							}, {
								name: '完善企业主页',
								path: '/corporateImage?pathStaus=1'
							}]
						} else {
							this.navigation = [{
								name: '主页',
								path: '/home'
							}, {
								name: '/',
								path: '/'
							}, {
								name: '企业详情',
								path: '/corporateImage'
							}]
						}
						break;
					case '/positionManagement':
						this.defaultActive = "3"
						this.navigation = [{
							name: '主页',
							path: '/home'
						}, {
							name: '/',
							path: '/'
						}, {
							name: '职位管理',
							path: '/positionManagement'
						}]
						break;
					case '/jobDetails':
						this.defaultActive = "1"
						this.navigation = [{
							name: '主页',
							path: '/home'
						}, {
							name: '/',
							path: '/'
						}, {
							name: '生源详情',
							path: '/jobDetails'
						}]
						break;
					case '/addPosition':
						this.defaultActive = "3"
						this.navigation = [{
							name: '主页',
							path: '/home'
						}, {
							name: '/',
							path: '/'
						}, {
							name: '职位管理',
							path: '/positionManagement'
						}, {
							name: '/',
							path: '/'
						}, {
							name: '新增｜编辑职位',
							path: '/addPosition'
						}]
						break;
					case '/meeting':
						this.defaultActive = "7"
						this.navigation = [{
							name: '千校联合报名平台',
							path: '/meeting'
						}]
						break;
					case '/invoiceList':
						this.defaultActive = "5"
						this.navigation = [{
							name: '个人中心',
							path: '/personalCenter'
						}, {
							name: '/',
							path: '/'
						}, {
							name: '开票管理',
							path: '/invoiceList'
						}]
						break;
					case '/activityIntroduction':
						this.defaultActive = "7"
						this.navigation = [{
							name: '千校联合报名平台',
							path: '/meeting'
						}, {
							name: '/',
							path: '/'
						}, {
							name: '高校链接',
							path: '/activityIntroduction'
						}]
						break;
					case '/meetingDemo':
						this.defaultActive = "7"
						this.navigation = [{
							name: '千校联合报名平台',
							path: '/meetingDemo'
						}]
						break;
					case '/signup':
						this.defaultActive = "7"
						if (this.$route.query.pathStaus) {
							this.navigation = [{
									name: '双选会',
									path: '/meeting'
								},
								{
									name: '/',
									path: '/'
								}, {
									name: '发布岗位',
									path: '/signup?pathStaus=1'
								}
							]
						} else {
							this.navigation = [{
									name: '双选会',
									path: '/meeting'
								},
								{
									name: '/',
									path: '/'
								}, {
									name: '报名',
									path: '/signup'
								}
							]
						}
						break;
					case '/reglist':
						this.defaultActive = "7"
						this.navigation = [{
								name: '双选会',
								path: '/meeting'
							},
							{
								name: '/',
								path: '/'
							}, {
								name: '我的报名',
								path: '/reglist'
							}
						]
						break;
					case '/messageManagement':
						this.defaultActive = "4"
						this.navigation = [{
							name: '主页',
							path: '/home'
						}, {
							name: '/',
							path: '/'
						}, {
							name: '消息管理',
							path: '/messageManagement'
						}]
						break;
					case '/messageSearch':
						this.defaultActive = "4"
						this.navigation = [{
							name: '主页',
							path: '/home'
						}, {
							name: '/',
							path: '/'
						}, {
							name: '消息管理',
							path: '/messageManagement'
						}, {
							name: '/',
							path: '/'
						}, {
							name: '消息搜索',
							path: '/messageSearch'
						}]
						break;
					case '/resumeDownload':
						this.defaultActive = "4"
						this.navigation = [{
							name: '主页',
							path: '/home'
						}, {
							name: '/',
							path: '/'
						}, {
							name: '简历库',
							path: '/messageManagement',
							query: { resumeDatabase: '1' }
						}, {
							name: '/',
							path: '/'
						}, {
							name: '简历下载',
							path: '/resumeDownload'
						}]
						break;
					case '/resumeRecharge':
						this.defaultActive = "4"
						this.navigation = [{
							name: '主页',
							path: '/home'
						}, {
							name: '/',
							path: '/'
						}, {
							name: '简历库',
							path: '/messageManagement',
							query: { resumeDatabase: '1' }
						}, {
							name: '/',
							path: '/'
						}, {
							name: '简历充值管理',
							path: '/resumeRecharge'
						}]
						break;
					case '/personalCenter':
						this.defaultActive = "5"
						this.navigation = [{
							name: '主页',
							path: '/home'
						}, {
							name: '/',
							path: '/'
						}, {
							name: '个人中心',
							path: '/personalCenter'
						}]
						break;
					case '/communityPromotion':
						this.defaultActive = "5"
						this.navigation = [{
							name: '主页',
							path: '/home'
						}, {
							name: '/',
							path: '/'
						}, {
							name: '个人中心',
							path: '/personalCenter'
						}, {
							name: '/',
							path: '/'
						}, {
							name: '社区广告',
							path: '/communityPromotion'
						}]
						break;
					case '/systemSettings':
						this.defaultActive = "6"
						this.navigation = [{
							name: '主页',
							path: '/home'
						}, {
							name: '/',
							path: '/'
						}, {
							name: '系统设置',
							path: '/systemSettings'
						}]
						break;
					case '/accountManagement':
						this.defaultActive = "5"
						this.navigation = [{
							name: '主页',
							path: '/home'
						}, {
							name: '/',
							path: '/'
						}, {
							name: '个人中心',
							path: '/personalCenter'
						}, {
							name: '/',
							path: '/'
						}, {
							name: '账户管理',
							path: '/accountManagement'
						}]
						break;
					case '/jobShadowing':
						this.defaultActive = "7"
						this.navigation = [{
							name: '双选会',
							path: '/meeting'
						}, {
							name: '/',
							path: '/'
						}, {
							name: '学生访企探岗报名',
							path: '/jobShadowing'
						}]
						break;
					case '/wednesday':
						this.defaultActive = "7"
						this.navigation = [{
							name: '双选会',
							path: '/meeting'
						}, {
							name: '/',
							path: '/'
						}, {
							name: '名企校招宣讲',
							path: '/wednesday'
						}]
						break;
					case '/cooperation':
						this.defaultActive = "7"
						this.navigation = [{
							name: '个人中心',
							path: '/personalCenter'
						}, {
							name: '/',
							path: '/'
						}, {
							name: '校企合作需求发布',
							path: '/cooperation'
						}]
						break;
					case '/corporateApply':
						this.defaultActive = "7"
						this.navigation = [{
							name: '双选会',
							path: '/meeting'
						}, {
							name: '/',
							path: '/'
						}, {
							name: '万企线上招聘会',
							path: '/corporateApply'
						}]
						break;
					default:
						break;
				}
			},
			updateMessageManagementNavigation(isResumeDatabase) {
				if (this.$route.path !== '/messageManagement') return
				this.navigation = [{
					name: '主页',
					path: '/home'
				}, {
					name: '/',
					path: '/'
				}, {
					name: isResumeDatabase ? '简历库' : '消息管理',
					path: '/messageManagement'
				}]
			},
			navigationTo(item) {
				if (item.path == '/meeting') {
					let is_demo = sessionStorage.getItem('demo')
					if (is_demo) {
						this.$router.push({
							path: '/meeting?demo='+is_demo,
						})
					} else {
						this.$router.push({
							path: '/meeting',
						})
					}
				} else {
					this.$router.push({
						path: item.path,
						query: item.query,
					});
				}

			},
			loginOut() {
				this.setAdminId('')
				this.setUserInfo('')
				this.setSchoolData('')
				this.setUserId('')
				this.setToken(null)
				localStorage.removeItem('user_id')
				localStorage.removeItem('userInfo')
				localStorage.removeItem('schoolData')
				localStorage.removeItem('admin_id')
				localStorage.removeItem('nextToken')
				//缺少清空vuex储存的数据
				this.$message({
					type: 'success',
					message: '退出成功'
				});
				setTimeout(() => {
					console.log(this.nextToken)
					if (this.$route.path == '/meeting') {

					} else {
						this.$router.push({
							path: `/login`,
							// query: {
							//   id: 1,
							// },
						});
					}
				}, 1000)


			},
			handleOpen(key, keyPath) {

			},
			menuSelect(key, keyPath) {

				let routerName = '/home'
				switch (key) {
					case '1':
						routerName = '/home'
						break;
					case '2':
						routerName = '/corporateImage'
						break;
					case '3':
						routerName = '/positionManagement'
						break;
					case '4':
						routerName = '/messageManagement'
						break;
					case '5':
						routerName = '/personalCenter'
						break;
					case '6':
						routerName = '/systemSettings'
						break;
					case '7':
						routerName = '/meeting'
						break;
				}
				if (this.$route.path != routerName) {
					if (routerName == '/meeting') {
						let is_demo = sessionStorage.getItem('demo')
						if (is_demo) {
							this.$router.push({
								path: '/meeting?demo='+is_demo,
							})
						} else {
							this.$router.push({
								path: '/meeting',
							})
						}
					} else {
						this.$router.push({
							path: routerName,
							// query: {
							//   id: 1,
							// },
						});
					}

				}



			},
			toggleFullScreen() {
				if (!document.fullscreenElement) {
					this.enterFullScreen();
					this.fullscreen = true
				} else {
					this.exitFullScreen();
					this.fullscreen = false
				}
			},


			enterFullScreen() {
				let element = document.documentElement;
				if (element.requestFullscreen) {
					element.requestFullscreen();
				} else if (element.mozRequestFullScreen) {
					/* Firefox */
					element.mozRequestFullScreen();
				} else if (element.webkitRequestFullscreen) {
					/* Chrome, Safari & Opera */
					element.webkitRequestFullscreen();
				} else if (element.msRequestFullscreen) {
					/* IE/Edge */
					element.msRequestFullscreen();
				}
			},

			exitFullScreen() {
				if (document.exitFullscreen) {
					document.exitFullscreen();
				} else if (document.mozCancelFullScreen) {
					/* Firefox */
					document.mozCancelFullScreen();
				} else if (document.webkitExitFullscreen) {
					/* Chrome, Safari and Opera */
					document.webkitExitFullscreen();
				} else if (document.msExitFullscreen) {
					/* IE/Edge */
					document.msExitFullscreen();
				}
			},

		},
		components: {},
	}
</script>
<style>
	#index .previewDialogVisible .preview .el-dialog {
		background: #fff !important;
		box-shadow: 0 1px 3px rgba(0, 0, 0, .3) !important;
	}

	#index .previewDialogVisible .el-dialog {
		background: initial;
		box-shadow: initial;
	}

	.activityVideo {
		display: block;
		width: 100%;
		height: 460px;
		object-fit: contain;
	}

	.activityVideoDialog .el-dialog__body {
		overflow: hidden;
	}

	.el-menu-vertical-demo:not(.el-menu--collapse) {
		width: 180px;
		min-height: 400px;
	}

	#index .el-menu {
		background: #225ac4;
	}

	#index .el-menu-item span {
		color: #ffffff;
	}

	#index .el-menu-item:focus,
	.el-menu-item:hover {
		outline: 0;

	}

	#index .el-menu-item.is-active {
		color: #225ac4;
		background-color: rgba(27, 72, 157) !important;
	}

	#index .el-menu-item.is-active span {
		color: #90c1ff;
	}

	#index .el-menu-item {
		position: relative;
	}

	#index .message-unread-badge {
		position: absolute;
		top: 8px;
		right: 12px;
		min-width: 16px;
		height: 16px;
		padding: 0 4px;
		box-sizing: border-box;
		border-radius: 8px;
		background: #f56c6c;
		color: #ffffff !important;
		font-size: 11px;
		line-height: 16px;
		text-align: center;
	}

	#index .changePassword .el-input__inner {
		border: none !important;
		text-align: right !important;
		background: initial !important;
		/* font-size: 16px !important; */
	}

	#index .changePassword .el-input__inner {
		border: none !important;
		text-align: right !important;
		background: initial !important;
		/* font-size: 16px !important; */
	}

	#index .previewDialogVisible .avatar-uploader .el-upload {
		border: 1px solid #E5E5E5;
		border-radius: 50%;
		cursor: pointer;
		position: relative;
		overflow: hidden;
		background: #F5F7FA;

		display: flex;
		align-items: center;
		flex-direction: column;
	}

	#index .previewDialogVisible .avatar-uploader1 .el-upload {
		border: 1px solid #E5E5E5;
		border-radius: 0 !important;
		cursor: pointer;
		position: relative;
		overflow: hidden;
		background: #F5F7FA;

		display: flex;
		align-items: center;
		flex-direction: column;
	}

	#index .previewDialogVisible .avatar-uploader .el-upload:hover {
		border-color: #409EFF;
	}

	#index .previewDialogVisible .avatarUploader {
		width: 80px !important;
		height: 80px !important;
		display: flex;
		align-items: center;
		flex-direction: column;
		justify-content: center;
	}

	#index .previewDialogVisible .avatar-uploader-icon1 {
		font-size: 14px;
		color: #8c939d;
		margin-bottom: 5px;
	}

	#index .previewDialogVisible .avatar-uploader span {
		font-weight: 400;
		font-size: 14px;
		color: #999999;
	}

	.avatar {
		width: 120px;
		height: 120px;
		display: block;
	}
</style>
<style lang="less" scoped>
	.closeImg {
		display: none;
	}

	.closeContainer:hover .closeImg {
		display: inline-block;
	}

	.container {
		width: 100%;
		display: flex;
		// align-items: center;
		background: #fff;

		.top {
			flex: 1;
		}

		.left {
			background: #1E40AF;
			// width: 200px;
			min-height: 100vh;
			border-bottom: 1px solid #e6e6e6;
			border-right: 1px solid #e6e6e6;
			display: flex;
			flex-direction: column;

			.bottom {
				width: 100%;
				display: flex;
				// align-items: center;
				// justify-content: center;
				flex-direction: column;
				font-size: 0;
				padding-bottom: 30px;
				padding: 0 20px 30px 20px;
                .img-box{
                   
                    
                    width: 120px;
                    height: 120px;
                    border: 6px solid #fff;
                    border-radius: 5px;
                    margin-bottom: 20px;
                    background: url('https://oss.sx985.com/2025/10/10/gh_1443x.jpg') no-repeat;
                    background-size: 100% 100%;
                    .imglogo{
                        display:block;
                        width:48px;
                        height:48px;
                        margin:30px auto;
                        border-radius:50%;
                    }
                    
                }
				img {
					// margin-left: 5px;
				}

				div {

					font-weight: 500;
					font-size: 14px;
					color: #fff;
					margin-left: 5px;
				}
			}

			.companyInfo {
				display: flex;
				align-items: center;
				width: 180px;
				font-size: 0;
				// margin-right: 20px;
				background: #003987;
				padding: 15px 15px;
				cursor: pointer;

				img {
					width: 24px;
					height: 24px;
					margin-right: 4px;
					margin-top: 1px;
					border-radius: 2px;
				}

				.company_name {
					width: 24px;
					height: 24px;
					margin-right: 8px;
					border-radius: 2px;
					text-align: center;
					line-height: 24px;
					// background-color: #FF6600;
					font-size: 16px;
					color: #fff;
				}

				.company_name1 {
					font-size: 14px;
					// color: #2D3C50;
					color: #fff;
					flex: 1;
					overflow: hidden;
					text-overflow: ellipsis;
					white-space: nowrap;
				}
			}

			.el-menu {
				border: none;
			}
		}

		.right {
			// flex: 1;
			width: calc(100vw - 181px);
			min-width: 0;
			overflow-x: hidden;
			// min-height: 100vh;
			// height: 100vh;
			// display: flex;
			// align-items: center;
			// flex-direction: column;

			.rightMain {
				width: 100%;
				// flex: 1;
				height: calc(100vh - 58px);
				// min-height: 646px;
				overflow-y: scroll;

			}

		&.hasMeetingBanner {
			height: 100vh;
			overflow-y: auto;

				.rightMain {
					height: auto;
					overflow-y: visible;
				}
			}
		}
	}

	@media screen and (max-width: 768px) {
		.container {
			.left {
				display: none;
			}

			.right {
				width: 100%;
			}
		}
	}

	.meetingBanner {
		width: 100%;
		font-size: 0;

		img {
			display: block;
			width: 100%;
			height: auto;
		}
	}

	.rightHeader {
		width: 100%;
		height: 56px;
		display: flex;
		align-items: center;
		border-bottom: 2px solid #F5FAFF;
		background: #fff;
		padding: 0 25px;



		.titleContainer {
			display: flex;
			align-items: center;
			justify-content: space-between;
			font-size: 0;

			img {
				width: 20px;
				height: 20px;
				// background: #225ac4;
				margin-right: 4px;
				margin-top: 1px;
			}

			.navigation {
				display: flex;
				align-items: center;

				.navigationItem {
					font-weight: bold;
					font-size: 14px;
					color: #2D3C50;
					margin-right: 5px;

				}
			}

		}

		.center {
			flex: 1;
		}

		.userInfo {
			display: flex;
			align-items: center;

			.meetingDocumentButton {
				display: flex;
				align-items: center;
				gap: 8px;

				.activityIntroductionText {
					font-weight: bold;
					font-size: 14px;
					color: #2D3C50;
				}

				.activityAction {
					display: flex;
					align-items: center;
					justify-content: center;
					height: 26px;
					padding: 0 10px;
					border: 1px solid;
					border-radius: 5px;
					box-sizing: border-box;
					font-size: 14px;
					font-weight: bold;
					line-height: 1;
					cursor: pointer;
					text-decoration: none;

					img {
						width: 14px;
						height: 14px;
						margin-right: 4px;
					}
				}

				.schoolLink {
					color: #1677ff;
					background: #f2f8ff;
					border-color: #95c7ff;
				}

				.documentLink {
					color: #5a9b3d;
					background: #f4fff0;
					border-color: #a8d995;
				}

				.videoLink {
					color: #315ccf;
					background: #f1f5ff;
					border-color: #a7bdf9;
				}
			}
            .meetingline{
                width: 1px;
                background: gray;
                height:10px;
                margin-top: 2px;
                opacity: 0.3;
                margin-left: 20px;
                margin-right: 10px;
            }
			.fullScreen {
				margin-right: 5px;
				font-size: 0;

				.img1 {
					width: 20px;
					height: 20px;
					// background: #225ac4;
				}
			}
			.userInfoMain {
				font-size: 0;
				display: flex;
				align-items: center;


				.img2 {
					width: 35px;
					height: 35px;
					// background: #225ac4;
					margin-right: 5px;
					border-radius: 50%;
				}

				.img3 {
					width: 15px;
					height: 15px;
					// background: #225ac4;
				}
			}
		}
	}


	.changePassword {
		.elDialogContainer {

			.ipt {
				width: 100%;
				display: flex;
				align-items: center;
				margin-bottom: 20px;
				border: 1px solid #DCDFE6;
				border-radius: 4px;
				padding: 0 15px;

				.text {
					// width: 135px;
					display: flex;
					align-items: center;
					font-weight: 400;
					font-size: 16px;
					color: #343232;
				}

				.el-input {
					flex: 1 !important;
				}

				.el-select {
					flex: 1 !important;
				}

				.el-textarea {
					flex: 1 !important;
				}
			}
		}
	}






	.changePassword {
		display: flex;
		align-items: center;

		.uploadText {
			width: 310px;
			font-weight: 500;
			font-size: 14px;
			color: #999999;
		}
	}



	.previewElDialog {
		position: relative;
		font-size: 0;

		.main {
			box-sizing: border-box;
			padding: 30px 50px 50px 50px;
			background: #FFFFFF;
			border-radius: 10px;

			.title {
				font-weight: bold;
				font-size: 16px;
				color: #2A2929;
				margin-bottom: 30px;
			}
		}

		.close {
			position: absolute;
			top: -28px;
			right: -28px;
			width: 32px;
			height: 32px;
			cursor: pointer;
		}
	}


	.elDialogContainer {

		.ipt {
			width: 560px;
			// display: flex;
			// align-items: center;
			margin-bottom: 28px;

			.text {
				// width: 135px;
				display: flex;
				align-items: center;
				font-weight: 400;
				font-size: 16px;
				color: #000;
				margin-bottom: 20px;
			}

			.el-input {
				flex: 1 !important;
			}

			.el-select {
				flex: 1 !important;
			}

			.el-textarea {
				flex: 1 !important;
			}




		}


	}
</style>
